import { createPortal } from 'react-dom';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function QuestionModal({ text, callback }: any) {
    const { useEffect, useState } = useGlobal();
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            {isClient &&
                createPortal(
                    <div className={`question-modal ${css['question-modal']}`}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <span className="close" onClick={callback}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M6 5L19 18M19 5L6 18" stroke="black" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                            </div>
                            <div className="modal-body">
                                <p className="modal-text">{text}</p>
                            </div>
                        </div>
                        <style jsx global>
                            {`
                                .announcement-bar {
                                    z-index: 100;
                                }
                                .ecoflow-frame-header {
                                    z-index: 150 !important;
                                }
                                .festival-float {
                                    z-index: 180;
                                }
                            `}
                        </style>
                    </div>,
                    document.body,
                )}
        </>
    );
}
